import { z } from 'zod'
import { monosanFetch } from '@/shared/api/monosanFetch'
import { tokenStore } from '@/features/auth/model/tokenStore'
import { clearLastActivityAt } from '@/features/auth/model/idleActivityStore'

export const logout = async (): Promise<void> => {
  try {
    await monosanFetch('/api/auth/logout', {
      method: 'POST',
      schema: z.null(),
      skipAuth: true,
      requiresCookie: true,
    })
  } finally {
    tokenStore.clear()
    clearLastActivityAt()
  }
}
